module.exports = __webpack_public_path__ + "img/new-tag.5c549ca2.svg";